<app-breadcrumb [title]="'Programación de Mantenimientos'" [items]="['Mantenimientos']"
    [active_item]="'Programación de mantenimientos'">
</app-breadcrumb>

<div class="container-fluid py-4">

    <!-- Buscador -->
   
<div class="filters-card">

  <!-- ENCABEZADO -->
  <div class="filters-header">
    <div>
      <h5 class="filters-title">
        <i class="icofont icofont-filter"></i>
        Filtros de programación
      </h5>
      <p class="filters-subtitle">
        Filtra las programaciones por estado, fecha, vehículo o plan.
      </p>
    </div>

    <div class="results-count">
      <i class="icofont icofont-check"></i>
      <span>{{ programacionesFiltradas.length }}</span>
      {{ programacionesFiltradas.length === 1 ? 'resultado' : 'resultados' }}
    </div>
  </div>

  <!-- FILTROS PRINCIPALES -->
  <div class="filters-grid">

    <!-- ESTADO -->
    <div class="filter-field">
      <label for="estadoProgramacion">
        Estado de programación: <span class="required">*</span>
      </label>
<!-- Estado -->
<select id="estadoProgramacion" class="form-select" [(ngModel)]="estadoProgramacionSeleccionado"
    name="estadoProgramacion" required>

    <option [ngValue]="null" disabled>
        Seleccione un estado
    </option>

    <option *ngFor="let estado of estadosProgramacion" [ngValue]="estado.id">
        {{ estado.nombre | uppercase }}
    </option>
</select>
    </div>

    <!-- FECHA INICIAL -->
    <div class="filter-field">
      <label for="fechaInicial">Fecha inicial: <span class="required">*</span></label>

      <input
        id="fechaInicial"
        type="date"
        class="form-control"
        [(ngModel)]="fechaInicial"
        required
        (ngModelChange)="resetearPaginacion()">
    </div>

    <!-- FECHA FINAL -->
    <div class="filter-field">
      <label for="fechaFinal">Fecha final: <span class="required">*</span></label>

      <input
        id="fechaFinal"
        type="date"
        class="form-control"
        [min]="fechaInicial || null"
        [(ngModel)]="fechaFinal"
        required
        (ngModelChange)="resetearPaginacion()">
    </div>

    <!-- VEHÍCULO -->
    <div class="filter-field">
      <label for="filtroPlaca">Vehículo</label>

      <select
        id="filtroPlaca"
        class="form-select"
        [(ngModel)]="filtroPlaca"
        (ngModelChange)="resetearPaginacion()">

        <option value="">Todos los vehículos</option>

        <option *ngFor="let placa of placasDisponibles" [value]="placa">
          {{ placa }}
        </option>
      </select>
    </div>

    <!-- PLAN -->
    <div class="filter-field">
      <label for="filtroPlan">Plan de mantenimiento</label>

      <select
        id="filtroPlan"
        class="form-select"
        [(ngModel)]="filtroPlan"
        (ngModelChange)="resetearPaginacion()">

        <option value="">Todos los planes</option>

        <option *ngFor="let plan of planesDisponibles" [value]="plan">
          Plan {{ plan }}
        </option>
      </select>
    </div>

  </div>

  <!-- ACCIONES -->
  <div class="filters-actions" *ngIf="hayFiltrosActivos">
    <span class="active-filters-label">
      <i class="icofont icofont-filter"></i>
      Filtros aplicados
    </span>

    <button
      type="button"
      class="btn-clear-filters"
      (click)="limpiarFiltros()">

      <i class="icofont icofont-close"></i>
      Limpiar filtros
    </button>
  </div>

  <!-- FILTROS ACTIVOS -->
  <div class="active-filters" *ngIf="hayFiltrosActivos">

    <span class="filter-chip" *ngIf="textoBusqueda">
      Búsqueda: {{ textoBusqueda }}
      <button type="button" aria-label="Quitar búsqueda"
        (click)="textoBusqueda = ''; resetearPaginacion()">×</button>
    </span>

    <span class="filter-chip" *ngIf="estadoProgramacionSeleccionado !== null">
      Estado:
      {{ nombreEstadoSeleccionado }}
      <button type="button" aria-label="Quitar estado"
        (click)="estadoProgramacionSeleccionado = null; resetearPaginacion()">×</button>
    </span>

    <span class="filter-chip" *ngIf="fechaInicial">
      Desde: {{ fechaInicial }}
      <button type="button" aria-label="Quitar fecha inicial"
        (click)="fechaInicial = ''; resetearPaginacion()">×</button>
    </span>

    <span class="filter-chip" *ngIf="fechaFinal">
      Hasta: {{ fechaFinal }}
      <button type="button" aria-label="Quitar fecha final"
        (click)="fechaFinal = ''; resetearPaginacion()">×</button>
    </span>

    <span class="filter-chip" *ngIf="filtroPlaca">
      Vehículo: {{ filtroPlaca }}
      <button type="button" aria-label="Quitar vehículo"
        (click)="filtroPlaca = ''; resetearPaginacion()">×</button>
    </span>

    <span class="filter-chip" *ngIf="filtroPlan">
      Plan: {{ filtroPlan }}
      <button type="button" aria-label="Quitar plan"
        (click)="filtroPlan = ''; resetearPaginacion()">×</button>
    </span>

    <span class="filter-chip" *ngIf="filtroControl">
      Criterio: {{ filtroControl === 'KM' ? 'Kilometraje' : 'Tiempo' }}
      <button type="button" aria-label="Quitar criterio"
        (click)="filtroControl = ''; resetearPaginacion()">×</button>
    </span>

    <span class="filter-chip" *ngIf="filtroEstado">
      Estado actual: {{ filtroEstado }}
      <button type="button" aria-label="Quitar estado actual"
        (click)="filtroEstado = ''; resetearPaginacion()">×</button>
    </span>

  </div>

  <div class="filters-actions">

  <span class="active-filters-label">
    <i class="icofont icofont-filter"></i>
    Consulta de programaciones
  </span>

  <div class="filter-buttons">

    <button
      type="button"
      class="btn btn-primary"
      (click)="consultarProgramaciones()">

      <i class="icofont icofont-search"></i>
      Consultar
    </button>

    <!-- <button
      type="button"
      class="btn btn-secondary"
      (click)="limpiarFiltros()">

      <i class="icofont icofont-close"></i>
      Limpiar filtros
    </button> -->

  </div>
</div>

</div>
    <div class="orden-selection-toolbar" *ngIf="programacionesSeleccionadas.length > 0">

        <div class="orden-selection-info">

            <div class="orden-selection-icon">
                <i class="icofont icofont-tasks-alt"></i>
            </div>

            <div>
                <strong>
                    {{ programacionesSeleccionadas.length }}
                    actividad(es) seleccionada(s)
                </strong>

                <small>
                    Vehículo {{ vehiculoSeleccionadoOrden }}
                </small>
            </div>

        </div>

        <div class="orden-selection-actions">

            <button type="button" class="btn btn-light btn-sm" (click)="limpiarSeleccionOrden()">

                <i class="icofont icofont-close"></i>
                Limpiar
            </button>

            <button type="button" class="btn btn-primary" (click)="abrirModalGenerarOrdenSeleccionadas()">

                <i class="icofont icofont-ui-add"></i>

                Generar orden
                ({{ programacionesSeleccionadas.length }})

            </button>

        </div>

    </div>
    <!-- Tabla -->
    <div class="card border-0 shadow-sm rounded-4">
        <div class="table-responsive">
            <table class="table table-plans align-middle mb-0">
                <thead>
                    <tr>
                        <th class="text-center orden-select-column">
                            <input type="checkbox" class="form-check-input" [checked]="todasLasSeleccionablesMarcadas()"
                                [indeterminate]="haySeleccionParcial()" (change)="seleccionarTodasLasVisibles($event)"
                                title="Seleccionar actividades">
                        </th>
                        <th>FECHA</th>
                        <th>VEHÍCULO</th>
                        <th>CÓDIGO PLAN</th>
                        <th>ACTIVIDAD</th>
                        <th>CRITERIO DE FRECUENCIA</th>

                        <th class="text-center">ÚLTIMO MANTENIMIENTO</th>
                        <th class="text-center">PRÓXIMO MANTENIMIENTO</th>

                        <th class="text-center">RESTANTE</th>
                        <th>UMBRAL DE ALERTA</th>
                        <th class="text-center">INICIO DE ALERTA</th>
                        <th class="text-center">VIGENCIA</th>
                        <th class="text-center">ESTADO ACTUAL</th>
                        <th class="text-center">ACCIONES</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of programacionesPaginadas">
                        <td class="text-center orden-select-column">
                            <input type="checkbox" class="form-check-input orden-checkbox"
                                [checked]="estaSeleccionadaParaOrden(item)"
                                [disabled]="!puedeSeleccionarParaOrden(item) || item.estado == 0"
                                (change)="toggleSeleccionOrden(item)" [title]="
                                    puedeSeleccionarParaOrden(item)
                                        ? 'Seleccionar actividad'
                                        : 'Solo disponible para mantenimientos próximos o vencidos'
                                ">

                        </td>
                    <td>
                        <div class="vehicle-cell">
                            {{ item.fecha_programacion ? (item.fecha_programacion | date:'dd/MM/yyyy':'UTC') : '—' }}
                        </div>
                    </td>
                        <td>
                            <div class="d-flex align-items-center gap-3">

                                <div>
                                    <div class="plan-code">{{ item.placa }}</div>
                                    <!-- <div class="vehicle-interno">
                                        Interno:
                                        <strong>
                                            {{ item?.VehicleModel?.interno || '—' }}
                                        </strong>
                                    </div> -->
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="vehicle-cell">{{ item.plan_mantenimiento_id || '—' }}</div>
                        </td>
                        <td>
                            <div class="vehicle-cell">{{
                                item.PlanMantenimientoActividad.servicioRealizado.tipo_de_mantenimiento || '—' }}</div>
                        </td>
                        <div *ngIf="item.PlanMantenimientoActividad.tipoControl=='KM'">
                            <td>
                                <div class="vehicle-cell scope-chip scope-open">{{ item.frecuencia_km || '—' }} {{
                                    item.PlanMantenimientoActividad.tipoControl || '—'
                                    }}</div>
                            </td>
                        </div>
                        <div *ngIf="item.PlanMantenimientoActividad.tipoControl=='MESES'">
                            <td>
                                <div class="vehicle-cell scope-chip scope-open">{{ item.frecuencia_meses || '—' }} {{
                                    item.PlanMantenimientoActividad.tipoControl || '—' }}</div>
                            </td>
                        </div>

                        <!--  <td>
                            <span class="scope-chip scope-open">
                                <i class="bi bi-arrow-repeat"></i>
                                {{ item.PlanMantenimientoActividad.tipoControl || '—' }}
                            </span>
                        </td> -->
                        <!-- ÚLTIMO -->
                        <td class="text-center">

                            <ng-container [ngSwitch]="item.PlanMantenimientoActividad?.tipoControl">

                                <!-- KILOMETRAJE -->
                                <span *ngSwitchCase="'KM'">
                                    {{ item.km_base | number:'1.0-0' }} KM

                                </span>


                                <!-- MESES -->
                                <span *ngSwitchCase="'MESES'">
                                    {{ item.fecha_base ? (item.fecha_base | date:'dd/MM/yyyy') : '—' }}
                                </span>

                                <!-- KM + MESES -->
                                <span *ngSwitchCase="'KM_MESES'">

                                    <span *ngIf="item.km_base">
                                        {{ item.km_base | number:'1.0-0' }} KM
                                    </span>

                                    <span *ngIf="item.km_base && item.fecha_base" class="mx-1">
                                        /
                                    </span>

                                    <span *ngIf="item.fecha_base">
                                        {{ item.fecha_base | date:'dd/MM/yyyy' }}
                                    </span>

                                    <span *ngIf="!item.km_base && !item.fecha_base">
                                        —
                                    </span>

                                </span>

                                <span *ngSwitchDefault>
                                    —
                                </span>

                            </ng-container>

                        </td>
                        <!-- PROXIMO -->
                        <td class="text-center">

                            <ng-container [ngSwitch]="item.PlanMantenimientoActividad?.tipoControl">

                                <!-- KILOMETRAJE -->
                                <span *ngSwitchCase="'KM'">
                                    {{ item.proximo_km | number:'1.0-0' }} KM

                                </span>


                                <!-- MESES -->
                                <span *ngSwitchCase="'MESES'">
                                    {{ item.proxima_fecha ? (item.proxima_fecha | date:'dd/MM/yyyy') : '—' }}
                                </span>

                                <!-- KM + MESES -->
                                <span *ngSwitchCase="'KM_MESES'">

                                    <span *ngIf="item.proximo_km">
                                        {{ item.proximo_km | number:'1.0-0' }} KM
                                    </span>

                                    <span *ngIf="item.proximo_km && item.proxima_fecha" class="mx-1">
                                        /
                                    </span>

                                    <span *ngIf="item.proxima_fecha">
                                        {{ item.proxima_fecha | date:'dd/MM/yyyy' }}
                                    </span>

                                    <span *ngIf="!item.proximo_km && !item.proxima_fecha">
                                        —
                                    </span>

                                </span>

                                <span *ngSwitchDefault>
                                    —
                                </span>

                            </ng-container>

                        </td>



                        <!-- RESTANTE -->
                        <td class="text-center">

                            <ng-container [ngSwitch]="item.PlanMantenimientoActividad?.tipoControl">

                                <!-- KILOMETRAJE -->
                                <span *ngSwitchCase="'KM'" [ngClass]="{
                            'km-vencido': (item.proximo_km - item.VehicleModel.kilometraje) < 0,
                            'km-pendiente': (item.proximo_km - item.VehicleModel.kilometraje) >= 0
                          }">
                                    {{ item.proximo_km - item.VehicleModel?.kilometraje | number:'1.0-0' }} KM
                                </span> <!-- MESES -->
                                <span *ngSwitchCase="'MESES'">
                                    {{ calcularDiasEntreFechas(item.proxima_fecha, getFechaActual()) || '—' }} dias
                                </span>

                                <!-- KM + MESES -->
                                <span *ngSwitchCase="'KM_MESES'">

                                    <span *ngIf="item.alerta_km">
                                        {{ item.alerta_km | number:'1.0-0' }} KM
                                    </span>

                                    <span *ngIf="item.alerta_km && item.proxima_fecha" class="mx-1">
                                        /
                                    </span>

                                    <span *ngIf="item.proxima_fecha">
                                        {{ item.proxima_fecha | date:'dd/MM/yyyy' }}
                                    </span>

                                    <span *ngIf="!item.alerta_km && !item.proxima_fecha">
                                        —
                                    </span>

                                </span>

                                <span *ngSwitchDefault>
                                    —
                                </span>

                            </ng-container>

                        </td>
                        <!-- UMBRAL DE ALERTA -->

                        <td class="text-center">

                            <ng-container [ngSwitch]="item.PlanMantenimientoActividad?.tipoControl">

                                <!-- KILOMETRAJE -->
                                <span *ngSwitchCase="'KM'">
                                    {{ item.proximo_km - item.alerta_km | number:'1.0-0' || '—' }} KM

                                </span>


                                <!-- MESES -->
                                <span *ngSwitchCase="'MESES'">
                                    {{ item.alerta_dias || '—' }} dias
                                </span>

                                <!-- KM + MESES -->
                                <span *ngSwitchCase="'KM_MESES'">

                                    <span *ngIf="item.alerta_km">
                                        {{ item.alerta_km | number:'1.0-0' }} KM
                                    </span>

                                    <span *ngIf="item.alerta_km && item.proxima_fecha" class="mx-1">
                                        /
                                    </span>

                                    <span *ngIf="item.proxima_fecha">
                                        {{ item.proxima_fecha | date:'dd/MM/yyyy' }}
                                    </span>

                                    <span *ngIf="!item.alerta_km && !item.proxima_fecha">
                                        —
                                    </span>

                                </span>

                                <span *ngSwitchDefault>
                                    —
                                </span>

                            </ng-container>

                        </td>
                        <!-- ALERTA -->
                        <td class="text-center">

                            <ng-container [ngSwitch]="item.PlanMantenimientoActividad?.tipoControl">

                                <!-- KILOMETRAJE -->
                                <span *ngSwitchCase="'KM'">
                                    {{ item.alerta_km | number:'1.0-0' || '—' }} KM

                                </span>


                                <!-- MESES -->
                                <span *ngSwitchCase="'MESES'">
                                    {{ item.fecha_alerta ? (item.fecha_alerta | date:'dd/MM/yyyy') : '—' }}
                                </span>

                                <!-- KM + MESES -->
                                <span *ngSwitchCase="'KM_MESES'">

                                    -

                                </span>

                                <span *ngSwitchDefault>
                                    —
                                </span>

                            </ng-container>

                        </td>
                        <td class="text-center">
                            <span class="status-pill" [ngClass]="obtenerClaseEstado(item)">
                                <span class="dot"></span>

                                {{ obtenerEstado(item) }}
                            </span> <!-- Fin del estado -->
                        </td>
                        <td class="text-center">
                            <span class="badge"
                                [ngClass]="item.estado == 1 ? 'badge bg-success' : 'badge bg-secondary'">
                                {{ item.estadoProgramacion.codigo }}
                            </span>
                        </td>
                        <td>
                            <div class="acciones-row">
                                <button type="button" class="btn btn-sm btn-outline-primary btn-rounded"
                                    title="Ver detalle" (click)="verDetalle(item)">
                                    <i class="icofont icofont-eye-alt"></i>
                                </button>
                                <!-- cancelar ORDEN -->

                                <button type="button" *ngIf="item.estado_programacion_id != 5 && item.estado_programacion_id != 4" class="btn btn-sm btn-outline-danger btn-rounded"
                                    title="Cancelar Actividad" (click)="cambiarEstadoActividad(item,5)">
                                    <i class="icofont icofont-trash"></i>
                                </button>

                                <button type="button" *ngIf="item.estado_programacion_id == 5"
                                    class="btn btn-sm btn-outline-success btn-rounded" title="Activar Actividad"
                                    (click)="cambiarEstadoActividad(item,2)">
                                    <i class="icofont icofont-check"></i>
                                </button>
                            </div>
                        </td>
                    </tr>

                    <!-- estado vacío -->
                    <tr *ngIf="!cargando && programacionesPaginadas.length === 0">
                        <td colspan="12" class="text-center py-5">
                            <div class="empty-state">
                                <i class="icofont icofont-inbox"></i>
                                <p class="mb-1 fw-semibold">No se encontraron programaciones</p>
                                <p class="text-secondary mb-0 small">Ajusta la búsqueda o verifica que existan
                                    programaciones registradas.</p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- pie de la card -->
            <div class="table-footer" *ngIf="programacionesFiltradas.length > 0">
                <div class="d-flex align-items-center gap-2">
                    <span class="text-secondary small">Mostrando {{ rangoMostrado }}</span>
                    <select class="form-select form-select-sm items-select" [(ngModel)]="itemsPorPagina"
                        (ngModelChange)="cambiarItemsPorPagina()">
                        <option *ngFor="let n of opcionesItemsPorPagina" [ngValue]="n">{{ n }} / página</option>
                    </select>
                </div>

                <nav aria-label="Paginación de programaciones">
                    <ul class="pagination pagination-sm mb-0">
                        <li class="page-item" [class.disabled]="paginaActual === 1">
                            <button class="page-link" (click)="paginaAnterior()">
                                <i class="icofont icofont-rounded-left"></i>
                            </button>
                        </li>
                        <li class="page-item" *ngFor="let p of paginasVisibles" [class.active]="p === paginaActual"
                            [class.disabled]="p === '...'">
                            <button class="page-link" (click)="irAPagina(p)">{{ p }}</button>
                        </li>
                        <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
                            <button class="page-link" (click)="paginaSiguiente()">
                                <i class="icofont icofont-rounded-right"></i>
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>


    <!-- =========================================================
     MODAL - DETALLE DE PROGRAMACIÓN
========================================================= -->
    <div class="modal-detalle-backdrop" *ngIf="mostrarModalDetalle" (click)="cerrarModalDetalle()">

        <div class="modal-detalle" (click)="$event.stopPropagation()">

            <!-- HEADER -->
            <div class="modal-detalle-header">

                <div class="modal-title-wrapper">

                    <div class="modal-title-icon">
                        <i class="icofont icofont-tools"></i>
                    </div>

                    <div>
                        <h3>
                            Detalle de programación de mantenimiento
                        </h3>

                        <span>
                            Programación #{{ programacionSeleccionada?.id }}
                            · Plan {{ programacionSeleccionada?.plan_mantenimiento_id }}
                        </span>
                    </div>

                </div>

                <button type="button" class="modal-close" (click)="cerrarModalDetalle()" title="Cerrar">

                    <i class="icofont icofont-close"></i>

                </button>

            </div>


            <!-- CONTENIDO -->
            <div class="modal-detalle-body">

                <!-- =================================================
                 VEHÍCULO
            ================================================== -->
                <section class="detalle-section">

                    <div class="section-title">

                        <i class="fa fa-bus"></i>

                        <span>VEHÍCULO</span>

                    </div>


                    <div class="vehicle-detail-card">

                        <div class="vehicle-detail-left">

                            <div class="vehicle-information">

                                <div class="vehicle-plate">
                                    {{ programacionSeleccionada?.placa || '—' }}
                                </div>

                                <div class="vehicle-interno">
                                    Interno:
                                    <strong>
                                        {{ programacionSeleccionada
                                        ?.VehicleModel
                                        ?.interno || '—' }}
                                    </strong>
                                </div>

                                <div class="vehicle-kilometraje">

                                    Kilometraje actual:

                                    <strong>
                                        {{
                                        programacionSeleccionada
                                        ?.VehicleModel
                                        ?.kilometraje
                                        | number:'1.0-0'
                                        }}
                                        KM
                                    </strong>

                                </div>

                            </div>

                        </div>


                        <!-- ESTADO -->
                        <div class="vehicle-status-card" [ngClass]="obtenerClaseEstado(programacionSeleccionada)">

                            <span class="status-pill" [ngClass]="obtenerClaseEstado(programacionSeleccionada)">

                                <span class="dot"></span>

                                {{ obtenerEstado(programacionSeleccionada) }}

                            </span>

                            <small>
                                Estado actual de la programación
                            </small>

                        </div>

                    </div>

                </section>


                <!-- =================================================
                 INFORMACIÓN DEL MANTENIMIENTO
            ================================================== -->
                <section class="detalle-section">

                    <div class="section-title">

                        <i class="icofont icofont-tools"></i>

                        <span>
                            INFORMACIÓN DEL MANTENIMIENTO
                        </span>

                    </div>


                    <div class="information-grid">

                        <!-- PLAN -->
                        <div class="information-card">

                            <span class="information-label">
                                Plan de mantenimiento
                            </span>

                            <strong>
                                {{ programacionSeleccionada?.plan_mantenimiento_id || '—' }}
                            </strong>

                        </div>


                        <!-- ACTIVIDAD -->
                        <div class="information-card">

                            <span class="information-label">
                                Actividad
                            </span>

                            <strong>
                                {{
                                programacionSeleccionada
                                ?.PlanMantenimientoActividad
                                ?.servicioRealizado
                                ?.tipo_de_mantenimiento || '—'
                                }}
                            </strong>

                        </div>


                        <!-- CRITERIO -->
                        <div class="information-card">

                            <span class="information-label">
                                Criterio de frecuencia
                            </span>

                            <div>

                                <span class="frequency-badge">

                                    <ng-container *ngIf="
                                        programacionSeleccionada
                                            ?.PlanMantenimientoActividad
                                            ?.tipoControl === 'KM'
                                    ">

                                        {{
                                        programacionSeleccionada?.frecuencia_km
                                        | number:'1.0-0'
                                        }}
                                        KM

                                    </ng-container>


                                    <ng-container *ngIf="
                                        programacionSeleccionada
                                            ?.PlanMantenimientoActividad
                                            ?.tipoControl === 'MESES'
                                    ">

                                        {{ programacionSeleccionada?.frecuencia_meses }}
                                        MESES

                                    </ng-container>

                                </span>

                                <div class="frequency-description">

                                    {{
                                    programacionSeleccionada
                                    ?.PlanMantenimientoActividad
                                    ?.tipoControl === 'KM'
                                    ? 'Kilometraje'
                                    : 'Tiempo'
                                    }}

                                </div>

                            </div>

                        </div>

                    </div>

                </section>


                <!-- =================================================
                 CONTROL DEL MANTENIMIENTO
            ================================================== -->
                <section class="detalle-section">

                    <div class="section-title">

                        <i class="icofont icofont-chart-bar"></i>

                        <span>
                            CONTROL DEL MANTENIMIENTO
                        </span>

                    </div>


                    <!-- ==============================
                     CONTROL POR KM
                =============================== -->
                    <ng-container *ngIf="
                        programacionSeleccionada
                            ?.PlanMantenimientoActividad
                            ?.tipoControl === 'KM'
                    ">

                        <div class="control-grid">

                            <!-- ÚLTIMO -->
                            <div class="control-card">

                                <div class="control-icon neutral">
                                    <i class="icofont icofont-clock-time"></i>
                                </div>

                                <div class="control-information">

                                    <span>
                                        Último mantenimiento
                                    </span>

                                    <strong>
                                        {{
                                        programacionSeleccionada?.km_base
                                        | number:'1.0-0'
                                        }}
                                        KM
                                    </strong>

                                </div>

                            </div>


                            <!-- PRÓXIMO -->
                            <div class="control-card">

                                <div class="control-icon danger-light">
                                    <i class="icofont icofont-dart"></i>
                                </div>

                                <div class="control-information">

                                    <span>
                                        Próximo mantenimiento
                                    </span>

                                    <strong>
                                        {{
                                        programacionSeleccionada?.proximo_km
                                        | number:'1.0-0'
                                        }}
                                        KM
                                    </strong>

                                </div>

                            </div>


                            <!-- RESTANTE -->
                            <div class="control-card">

                                <div class="control-icon blue-light">
                                    <i class="icofont icofont-road"></i>
                                </div>

                                <div class="control-information">

                                    <span>
                                        Restante
                                    </span>

                                    <strong [ngClass]="{
        'value-programado': obtenerEstado(programacionSeleccionada) === 'PROGRAMADO',
        'value-proximo': obtenerEstado(programacionSeleccionada) === 'PRÓXIMO',
        'value-vencido': obtenerEstado(programacionSeleccionada) === 'VENCIDO'
    }">
                                        {{
                                        programacionSeleccionada?.proximo_km -
                                        programacionSeleccionada?.VehicleModel?.kilometraje
                                        | number:'1.0-0'
                                        }}
                                        KM
                                    </strong>
                                </div>

                            </div>


                            <!-- ALERTA ANTES -->
                            <div class="control-card">

                                <div class="control-icon warning-light">
                                    <i class="icofont icofont-alarm"></i>
                                </div>

                                <div class="control-information">

                                    <span>
                                        Umbral de alerta
                                    </span>

                                    <strong>
                                        {{
                                        programacionSeleccionada?.proximo_km -
                                        programacionSeleccionada?.alerta_km
                                        | number:'1.0-0'
                                        }}
                                        KM
                                    </strong>

                                    <small>
                                        Alerta antes de vencer
                                    </small>

                                </div>

                            </div>


                            <!-- INICIO ALERTA -->
                            <div class="control-card">

                                <div class="control-icon danger-light">
                                    <i class="icofont icofont-calendar"></i>
                                </div>

                                <div class="control-information">

                                    <span>
                                        Inicio de alerta
                                    </span>

                                    <strong>
                                        {{
                                        programacionSeleccionada?.alerta_km
                                        | number:'1.0-0'
                                        }}
                                        KM
                                    </strong>

                                </div>

                            </div>

                        </div>

                    </ng-container>


                    <!-- ==============================
                     CONTROL POR MESES
                =============================== -->
                    <ng-container *ngIf="
                        programacionSeleccionada
                            ?.PlanMantenimientoActividad
                            ?.tipoControl === 'MESES'
                    ">

                        <div class="control-grid">

                            <!-- ÚLTIMO -->
                            <div class="control-card">

                                <div class="control-icon neutral">
                                    <i class="icofont icofont-clock-time"></i>
                                </div>

                                <div class="control-information">

                                    <span>
                                        Último mantenimiento
                                    </span>

                                    <strong>
                                        {{
                                        formatearFecha(
                                        programacionSeleccionada?.fecha_base
                                        )
                                        }}
                                    </strong>

                                </div>

                            </div>


                            <!-- PRÓXIMO -->
                            <div class="control-card">

                                <div class="control-icon danger-light">
                                    <i class="icofont icofont-check"></i>
                                </div>

                                <div class="control-information">

                                    <span>
                                        Próximo mantenimiento
                                    </span>

                                    <strong>
                                        {{
                                        formatearFecha(
                                        programacionSeleccionada?.proxima_fecha
                                        )
                                        }}
                                    </strong>

                                </div>

                            </div>


                            <!-- RESTANTE -->
                            <div class="control-card">

                                <div class="control-icon blue-light">
                                    <i class="icofont icofont-calendar"></i>
                                </div>

                                <div class="control-information">

                                    <span>
                                        Restante
                                    </span>

                                    <strong [ngClass]="{
                                        'value-vencido':
                                            diasRestantes(
                                                programacionSeleccionada?.proxima_fecha
                                            ) !== null &&
                                            diasRestantes(
                                                programacionSeleccionada?.proxima_fecha
                                            )! < 0
                                    }">

                                        {{
                                        diasRestantes(
                                        programacionSeleccionada?.proxima_fecha
                                        )
                                        }}
                                        días

                                    </strong>

                                </div>

                            </div>


                            <!-- ALERTA -->
                            <div class="control-card">

                                <div class="control-icon warning-light">
                                    <i class="icofont icofont-alarm"></i>
                                </div>

                                <div class="control-information">

                                    <span>
                                        Umbral de alerta
                                    </span>

                                    <strong>
                                        {{ programacionSeleccionada?.alerta_dias }}
                                        días
                                    </strong>

                                    <small>
                                        Alerta antes de vencer
                                    </small>

                                </div>

                            </div>


                            <!-- INICIO ALERTA -->
                            <div class="control-card">

                                <div class="control-icon danger-light">
                                    <i class="icofont icofont-calendar"></i>
                                </div>

                                <div class="control-information">

                                    <span>
                                        Inicio de alerta
                                    </span>

                                    <strong>
                                        {{
                                        formatearFecha(
                                        programacionSeleccionada?.fecha_alerta
                                        )
                                        }}
                                    </strong>

                                </div>

                            </div>

                        </div>

                    </ng-container>

                </section>


                <!-- =================================================
                 INFORMACIÓN DE REGISTRO
            ================================================== -->
                <section class="detalle-section">

                    <div class="section-title">

                        <i class="icofont icofont-info-circle"></i>

                        <span>
                            INFORMACIÓN DE REGISTRO
                        </span>

                    </div>


                    <div class="registration-grid">

                        <div class="registration-item">

                            <div class="registration-icon">
                                <i class="icofont icofont-calendar"></i>
                            </div>

                            <div>

                                <span>
                                    Fecha de programación
                                </span>

                                <strong>
                                    {{
                                    programacionSeleccionada?.fecha_programacion
                                    | date:'dd/MM/yyyy HH:mm'
                                    }}
                                </strong>

                            </div>

                        </div>


                        <div class="registration-item">

                            <div class="registration-icon">
                                <i class="icofont icofont-user"></i>
                            </div>

                            <div>

                                <span>
                                    Usuario
                                </span>

                                <strong>
                                    {{ programacionSeleccionada?.usuarioRegistro.email || '—' }}
                                </strong>

                            </div>

                        </div>


                        <div class="registration-item">

                            <div class="registration-icon">
                                <i class="icofont icofont-calendar"></i>
                            </div>

                            <div>

                                <span>
                                    Fecha de creación
                                </span>

                                <strong>
                                    {{
                                    programacionSeleccionada?.createdAt
                                    | date:'dd/MM/yyyy HH:mm'
                                    }}
                                </strong>

                            </div>

                        </div>

                    </div>

                </section>

            </div>


            <!-- FOOTER -->
            <div class="modal-detalle-footer">

                <button type="button" class="btn-modal-cerrar" (click)="cerrarModalDetalle()">

                    <i class="icofont icofont-close"></i>

                    Cerrar

                </button>

            </div>

        </div>

    </div>

    <!-- =========================================================
     MODAL GENERAR ORDEN DE MANTENIMIENTO
========================================================= -->

    <div class="modal-orden-backdrop" *ngIf="mostrarModalGenerarOrden" (click)="cerrarModalGenerarOrden()">

        <div class="modal-orden" (click)="$event.stopPropagation()">


            <!-- =================================================
             HEADER
        ================================================== -->

            <div class="modal-orden-header">

                <div class="modal-orden-title-wrapper">

                    <div class="modal-orden-icon">
                        <i class="icofont icofont-tools"></i>
                    </div>

                    <div>

                        <h3>
                            Generar orden de mantenimiento
                        </h3>

                        <span>
                            A partir de las actividades seleccionadas

                        </span>

                    </div>

                </div>


                <button type="button" class="modal-orden-close" title="Cerrar" (click)="cerrarModalGenerarOrden()">

                    <i class="icofont icofont-close"></i>

                </button>

            </div>


            <!-- =================================================
             BODY
        ================================================== -->

            <div class="modal-orden-body">


                <!-- =================================================
                 PROGRAMACIÓN DE ORIGEN
            ================================================== -->

                <section class="orden-section">

                    <div class="orden-section-title">

                        <i class="icofont icofont-link"></i>

                        <span>
                            PROGRAMACIÓN DE ORIGEN
                        </span>

                    </div>


                    <div class="programacion-origen">


                        <!-- VEHÍCULO -->
                        <div class="origen-item">

                            <span>
                                VEHÍCULO
                            </span>

                            <strong>
                                {{ programacionesSeleccionadas[0]?.placa }}
                            </strong>

                            <small>
                                Interno:
                                {{ programacionesSeleccionadas[0]?.VehicleModel?.interno || '—' }}
                            </small>

                        </div>


                        <!-- PLAN -->
                        <div class="origen-item">

                            <span>
                                CÓDIGO DEL PLAN
                            </span>

                            <strong>
                                #{{ programacionesSeleccionadas[0]?.plan_mantenimiento_id || '—' }}
                            </strong>

                        </div>

                        <div class="origen-item">

                            <span>
                                KILOMETRAJE ACTUAL
                            </span>

                            <strong>
                                {{ programacionesSeleccionadas[0]?.VehicleModel.kilometraje || '—' }} KM
                            </strong>

                        </div>
                    </div>

                </section>


                <!-- =================================================
                 ESTADO ACTUAL
            ================================================== -->

                <div class="orden-alerta">

                    <div class="orden-alerta-icon">

                        <i class="icofont" [ngClass]="{
                            'icofont-info-circle': true
                        }">
                        </i>

                    </div>


                    <div>

                        <strong>

                            Actividades seleccionadas
                        </strong>

                        <span>
                            Esta orden quedará asociada directamente a la programación seleccionada.
                        </span>

                    </div>

                </div>

                <section class="tbl-actividades-seleccinadas">
                    <table class="table table-plans align-middle mb-0 mt-3">
                        <thead>
                            <tr>
                                <th>Actividad</th>
                                <th class="text-center">Criterio</th>
                                <th class="text-center">Próximo Mantenimiento</th>
                                <th class="text-center">Restante</th>
                                <th class="text-center">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let actividad of programacionesParaOrden">

                                <!-- ACTIVIDAD -->
                                <td>
                                    <div class="vehicle-cell">
                                        {{
                                        actividad.PlanMantenimientoActividad?.servicioRealizado?.tipo_de_mantenimiento
                                        || '—' }}
                                    </div>
                                    <small class="text-muted">
                                        {{ actividad.PlanMantenimientoActividad?.servicioRealizado?.sistema || '' }}
                                    </small>
                                </td>

                                <!-- CRITERIO -->
                                <td class="text-center">
                                    <span class="scope-chip scope-open">
                                        {{ actividad.PlanMantenimientoActividad?.tipoControl || '—' }}
                                    </span>
                                </td>

                                <!-- PRÓXIMO MANTENIMIENTO -->
                                <td class="text-center">
                                    <ng-container [ngSwitch]="actividad.PlanMantenimientoActividad?.tipoControl">

                                        <span *ngSwitchCase="'KM'">
                                            {{ actividad.proximo_km | number:'1.0-0' }} KM
                                        </span>

                                        <span *ngSwitchCase="'MESES'">
                                            {{ actividad.proxima_fecha ? (actividad.proxima_fecha | date:'dd/MM/yyyy') :
                                            '—' }}
                                        </span>

                                        <span *ngSwitchCase="'KM_MESES'">
                                            <span *ngIf="actividad.proximo_km">
                                                {{ actividad.proximo_km | number:'1.0-0' }} KM
                                            </span>
                                            <span *ngIf="actividad.proximo_km && actividad.proxima_fecha"
                                                class="mx-1">/</span>
                                            <span *ngIf="actividad.proxima_fecha">
                                                {{ actividad.proxima_fecha | date:'dd/MM/yyyy' }}
                                            </span>
                                            <span *ngIf="!actividad.proximo_km && !actividad.proxima_fecha">—</span>
                                        </span>

                                        <span *ngSwitchDefault>—</span>
                                    </ng-container>
                                </td>

                                <!-- RESTANTE -->
                                <td class="text-center">
                                    <ng-container [ngSwitch]="actividad.PlanMantenimientoActividad?.tipoControl">

                                        <span *ngSwitchCase="'KM'">
                                            {{ (actividad.proximo_km ?? 0) - (actividad.VehicleModel?.kilometraje ?? 0)
                                            | number:'1.0-0' }} KM
                                        </span>

                                        <span *ngSwitchCase="'MESES'">
                                            {{ actividad.proxima_fecha ?
                                            (calcularDiasEntreFechas(actividad.proxima_fecha, getFechaActual()) + '
                                            días') : '—' }}
                                        </span>

                                        <span *ngSwitchCase="'KM_MESES'">
                                            <span *ngIf="actividad.proximo_km != null">
                                                {{ (actividad.proximo_km ?? 0) - (actividad.VehicleModel?.kilometraje ??
                                                0) | number:'1.0-0' }} KM
                                            </span>
                                            <span *ngIf="actividad.proximo_km != null && actividad.proxima_fecha"
                                                class="mx-1">/</span>
                                            <span *ngIf="actividad.proxima_fecha">
                                                {{ calcularDiasEntreFechas(actividad.proxima_fecha, getFechaActual()) }}
                                                días
                                            </span>
                                            <span
                                                *ngIf="actividad.proximo_km == null && !actividad.proxima_fecha">—</span>
                                        </span>

                                        <span *ngSwitchDefault>—</span>
                                    </ng-container>
                                </td>

                                <!-- ESTADO -->
                                <td class="text-center">
                                    <span class="status-pill" [ngClass]="obtenerClaseEstado(actividad)">
                                        <span class="dot"></span>
                                        {{ obtenerEstado(actividad) }}
                                    </span>
                                </td>

                            </tr>

                            <!-- sin selección -->
                            <tr *ngIf="!programacionesParaOrden.length">
                                <td colspan="5" class="text-center text-muted py-4">
                                    No hay actividades seleccionadas.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <!-- =================================================
                 DATOS DE LA ORDEN
            ================================================== -->

                <section class="orden-section">

                    <div class="orden-section-title">

                        <i class="icofont icofont-file-document"></i>

                        <span>
                            DATOS DE LA ORDEN
                        </span>

                    </div>


                    <div class="orden-form-grid">


                        <!-- TIPO -->
                        <div class="orden-form-group">

                            <label>
                                Tipo de mantenimiento *
                            </label>

                            <ng-select [items]="TipoMantenimiento" bindLabel="nombre" bindValue="id" [clearable]="false"
                                [(ngModel)]="ordenMantenimientoForm.tipo">
                            </ng-select>
                        </div>


                        <!-- PRIORIDAD -->
                        <div class="orden-form-group">

                            <label>
                                Prioridad *
                            </label>
                            <ng-select [items]="prioridades" bindLabel="nombre" bindValue="id"
                                placeholder="Seleccione una prioridad" [clearable]="false"
                                [(ngModel)]="ordenMantenimientoForm.prioridad">
                            </ng-select>


                        </div>


                        <!-- FECHA -->
                        <div class="orden-form-group">

                            <label>
                                Fecha programada *
                            </label>

                            <input type="date" class="form-control"
                                [(ngModel)]="ordenMantenimientoForm.fecha_programada">

                        </div>


                        <!-- KILOMETRAJE -->
                        <div class="orden-form-group">

                            <label>
                                Kilometraje de ingreso *
                            </label>

                            <div class="input-with-unit">

                                <input type="number" class="form-control" min="0" [(ngModel)]="
                                    ordenMantenimientoForm.kilometraje_ingreso
                                ">

                                <span>
                                    KM
                                </span>

                            </div>

                        </div>


                    </div>

                </section>


                <!-- =================================================
                 MOTIVO
            ================================================== -->

                <section class="orden-section">

                    <div class="orden-section-title">

                        <i class="icofont icofont-warning-alt"></i>

                        <span>
                            MOTIVO Y OBSERVACIONES
                        </span>

                    </div>


                    <div class="orden-form-group">

                        <label>
                            Motivo de mantenimiento *
                        </label>

                        <textarea class="form-control" rows="2" [(ngModel)]="ordenMantenimientoForm.motivo"
                            placeholder="Indique el motivo de generación de la orden...">
                    </textarea>

                    </div>


                    <div class="orden-form-group mt-3">

                        <label>
                            Observaciones iniciales <span class="text-danger">*</span>
                        </label>

                        <textarea class="form-control" rows="3" [(ngModel)]="ordenMantenimientoForm.observaciones"
                            placeholder="Observaciones adicionales...">
                    </textarea>

                    </div>

                </section>


                <!-- =================================================
                 TRAZABILIDAD PESV
            ================================================== -->

                <div class="pesv-trazabilidad">

                    <div class="pesv-icon">

                        <i class="icofont icofont-shield"></i>

                    </div>

                    <div>

                        <strong>
                            Trazabilidad del mantenimiento
                        </strong>

                        <span>
                            La orden quedará vinculada al vehículo,
                            plan, actividad y programación de mantenimiento.
                        </span>

                    </div>

                </div>

            </div>


            <!-- =================================================
             FOOTER
        ================================================== -->

            <div class="modal-orden-footer">

                <button type="button" class="btn-orden-cancelar" (click)="cerrarModalGenerarOrden()">

                    Cancelar

                </button>


                <button type="button" class="btn-orden-generar" (click)="generarOrdenMantenimiento()">

                    <i class="icofont icofont-plus"></i>

                    Generar orden

                </button>

            </div>

        </div>

    </div>
</div>